export enum StorageKeys {
  LocalSettings = 'local-settings',
}
